export default {
  "dashboard": {
    "create_modal_dialog": {
      "title": "Create a new {type}.",
      "folder_name_input": "Dashboard name",
      "submit_button": "Create dashboard"
    },
    "delete_modal_dialog": {
      "title": "Delete dashboard {name} ?",
      "description": "Are you sure you want to delete this dashboard?",
      "submit_button": "Delete dashboard"
    },
    "rename_modal_dialog": {
      "title": "Rename {type} {name}",
      "name_input": "{type} new name",
      "submit_button": "Update"
    },
    "add_widget_modal_dialog": {
      "title": "Add Visualization Widget",
      "description": "Select the visualization you want to add to your dashboard.",
      "tab": {
        "all": "All",
        "BAR_CHART": "Bar",
        "LINE_CHART": "Line",
        "PIE_CHART": "Pie",
        "DOUGHNUT_CHART": "Doughnut",
        "COLUMN_METRIC": "Metric",
        "TABLE": "Table",
        "GAUGE_CHART": "Gauge"
      },
      "add_button": "Add"
    },
    "add_filters_modal_dialog": {
      "title_add": "Add Dynamic Filters",
      "title_edit": "Update Dynamic Filters",
      "description": "Select which data column you want to be able to filter in your dashboard.",
      "label": "Filter Label",
      "type": "Input Type",
      "type_options": {
        "select": "Option Dropdown",
        "string": "Text",
        "number": "Number",
        "boolean": "Boolean",
        "date": "Date",
        "datetime": "Date with Time",
        "date_range": "Date Range",
        "datetime_range": "Date Range with Time"
      },
      "columns": "Column(s)",
      "add_column_button": "Add column to this filter",
      "add_filter_button": "New Filter",
      "delete_filter_button": "Delete Filter",
      "submit_button": "Add {count} filters to dashboard",
      "update_button": "Update filters",
      "missing_label": "Filter label is required",
      "missing_column": "Select a column",
      "add_column_first": "Add a column first",
      "default_value": "Default value"
    },
    "table_widget_dialog": {
      "title": "Add Data Table",
      "description": "Select which column from the visualization to view the data in your dashboard.",
      "viz": "Select Visualization",
      "columns": "Column(s)",
      "add_column_button": "Add column to this table",
      "submit_button": "Add table to dashboard",
      "update_button": "Update table"
    },
    "edit_button": "Edit",
    "rename_button": "Rename",
    "duplicate_button": "Duplicate",
    "duplicate_success": "Dashboard duplicated successfully",
    "edit_dashboard_button": "Edit Dashboard",
    "clear_filters_button": "Clear Filters",
    "clear_filters_confirm_button": "Confirm?",
    "view_only_button": "View Mode",
    "view_only_disabled_tooltip": "Save your changes before switching to View Mode",
    "select_value": "Select value",
    "dynamic_filters": {
      "loading_tooltip": "Waiting for visualization to finish loading",
      "loading_options": "Loading..."
    },
    "retry_button": "Retry",
    "settings_modal_dialog": {
      "title": "Dashboard Settings",
      "columns_label": "Number of Columns",
      "columns_required": "Please enter number of columns",
      "gap_label": "Gap Between Elements (px)",
      "gap_required": "Please enter gap size",
      "row_height_label": "Row Height (px)",
      "row_height_required": "Please enter row height",
      "recalculate_label": "Recalculate widget positions",
      "cache_enabled_label": "Query result caching",
      "cache_enabled_off": "Off",
      "cache_enabled_on": "On — cache results and reuse them",
      "cache_refresh_label": "Refresh behavior",
      "cache_refresh_no_auto": "No auto-refresh",
      "cache_refresh_auto": "Auto-refresh — keep recently used results fresh automatically",
      "cache_refresh_custom": "Custom — keep the filter combinations you choose fresh",
      "cache_custom_combinations_label": "Filter combinations to keep fresh",
      "cache_custom_combinations_placeholder": "Choose the filter combinations to refresh (preview)",
      "cache_custom_combination_add": "Add combination",
      "cache_auto_recency_days_label": "Recency window (days)",
      "cache_auto_recency_days_help": "How recently a cached result must have been used for auto-refresh to keep it fresh. Separate from the age limit above.",
      "staleness_tolerance_label": "Show cached data up to (age)",
      "staleness_tolerance_help": "The oldest a cached result can be and still be shown while fresh data loads. Applies to every caching mode.",
      "staleness_tolerance_required": "Please enter a staleness tolerance",
      "staleness_tolerance_minimum": "Staleness tolerance must be at least 1 minute",
      "staleness_unit_days": "days",
      "staleness_unit_hours": "hrs",
      "staleness_unit_minutes": "min",
      "submit_button": "Apply"
    },
    "widget_cache_staleness_tag": "Cached {when}",
    "widget_cache_staleness_tag_generic": "Cached data",
    "image_upload_widget": {
      "no_image": "No image uploaded",
      "edit_image_button": "Edit photo",
      "upload_button": "Upload an Image",
      "uploading": "Uploading...",
      "supported_formats": "Supported formats: JPG, PNG, SVG (Max 375KB)"
    },
    "widget_errors_title": "{count, plural, one {# widget failed to load} other {# widgets failed to load}}",
    "widget_errors_description": "Some widgets encountered errors while loading their data.",
    "widget_errors_retry_all": "Retry All",
    "widget_errors_show_dashboard": "Show Dashboard",
    "widget_render_error_title": "This widget couldn't be displayed",
    "widget_render_error_detail": "{type} widget ({id})"
  }
};
